import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UToggleSwitchComponent } from './u-toggle-switch.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [UToggleSwitchComponent],
  imports: [CommonModule, MatSlideToggleModule, ReactiveFormsModule],
  exports: [UToggleSwitchComponent],
})
export class UToggleSwitchModule {}
